import { render, staticRenderFns } from "./tzsbSearch.vue?vue&type=template&id=672d7008&scoped=true"
import script from "./tzsbSearch.vue?vue&type=script&lang=js"
export * from "./tzsbSearch.vue?vue&type=script&lang=js"
import style0 from "./tzsbSearch.vue?vue&type=style&index=0&id=672d7008&prod&lang=less&scoped=true"
import style1 from "./tzsbSearch.vue?vue&type=style&index=1&id=672d7008&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672d7008",
  null
  
)

export default component.exports